import { render, staticRenderFns } from "./CurrentYear.vue?vue&type=template&id=982dcd80&scoped=true"
import script from "./CurrentYear.vue?vue&type=script&lang=js"
export * from "./CurrentYear.vue?vue&type=script&lang=js"
import style0 from "./CurrentYear.vue?vue&type=style&index=0&id=982dcd80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982dcd80",
  null
  
)

export default component.exports